module.exports = __webpack_public_path__ + "img/pic1.8aa55701.png";